import React, { Component } from 'react';
import { Container } from 'components/styled-components';
import SystemConfiguration from 'containers/Manage-Admin/system-configuration/SystemConfiguration';
import EmailTemplates from 'containers/Manage-Admin/email-templates/EmailTemplates';
import AuditLog from 'containers/Manage-Admin/audit-log/AuditLog';
import { AdminManagementHeader } from 'components/forms/admin-management/header';
import Departments from 'containers/Manage-Admin/departments/departments';
import ApiUsers from 'containers/Manage-Admin/api-users';
import colors from 'utils/colors';
import styled from 'styled-components';

class AdminManagement extends Component {
  state = {
    activeTitle: 0,
  };

  handleChangeActive = activeTitle => this.setState({ activeTitle });

  render() {
    const { activeTitle } = this.state;
    const { appUser } = this.props;
    return (
      <Container>
        <HeadingWrapper>
          <AdminManagementHeader
            handleChangeActive={this.handleChangeActive}
            activeTitle={activeTitle}
            appUser={appUser}
          />
        </HeadingWrapper>

        {activeTitle === 0 && <SystemConfiguration />}
        {activeTitle === 1 && <Departments appUser={appUser} />}
        {activeTitle === 2 && <EmailTemplates />}
        {activeTitle === 3 && <AuditLog />}
        {activeTitle === 4 && <ApiUsers appUser={appUser} />}
      </Container>
    );
  }
}

const HeadingWrapper = styled.div`
  border-bottom: 1px solid ${colors.lightestGray};
  margin-bottom: 1rem;
`;

export default AdminManagement;
